import { ROUTE_TEXT_MATERIALS_CATEGORIES } from '@@partner:config/routes'
import TextMaterialCategoryForm from '@components/textMaterials/category/TextMaterialCategoryForm'
import React from 'react'
import { ArrowBackOutline } from 'react-ionicons'
import { generatePath, NavLink, useParams } from 'react-router-dom'
import { Nav, Navbar } from 'rsuite'

export default function TextMaterialCategoryFormPage () {
  const { categoryId, brandSlug } = useParams<any>()

  return (
    <div className="CustomerFormPage">
      <h1 className="u-heading">
        {categoryId ? 'Редактирование' : 'Добавление'} категории
      </h1>
      <Navbar appearance='subtle'>
        <Nav>
          <Nav.Item
            icon={<ArrowBackOutline />}
            as={NavLink}
            to={generatePath(ROUTE_TEXT_MATERIALS_CATEGORIES, {
              brandSlug
            })}
          >
             Вернуться к списку
          </Nav.Item>
        </Nav>
      </Navbar>
      <TextMaterialCategoryForm categoryId={categoryId} />
    </div>
  )
}